<template>
  <div>
    <transition
      name="fade"
      mode="out-in"
    >
      <template v-if="isBlocked">
        <Blocked
          key="blocked"
          :type="type"
          :price="formatedPrice"
          :submit="goToConfirm"
        />
      </template>
      <template v-else-if="isIdle">
        <Banner
          key="banner"
          :type="type"
          :price="formatedPrice"
          :submit="goToConfirm"
          :slug="slug"
          :variant="variant"
        />
      </template>
      <template v-else-if="isConfirming">
        <Confirmation
          key="confirmation"
          :type="type"
          :price="formatedPrice"
          :cancel="goToIdle"
          :submit="submitBooking"
          :requirements="requirements"
        />
      </template>
      <template v-else-if="isRunning">
        <InProgress
          key="inProgress"
          :slug="slug"
        />
      </template>
    </transition>
  </div>
</template>

<script>
import bus, { eventNames } from '@/lib/eventBus'
import currencyMixin from '@/mixins/currency'

import Banner from './Banner'
import Blocked from './Blocked'
import Confirmation from './Confirmation'
import UpsellingType from './enums/UpsellingType'
import InProgress from './InProgress.vue'

const StatusType = {
  IDLE: 'IDLE',
  CONFIRM: 'CONFIRM',
  RUNNING: 'RUNNING',
  BLOCKED: 'BLOCKED',
}

export default {
  components: {
    Banner,
    Confirmation,
    InProgress,
    Blocked,
  },

  mixins: [currencyMixin],

  props: {
    type: { type: String, default: UpsellingType.CHECKLIST },
    isBookingBlocked: { type: Boolean, default: true },
    slug: { type: String, default: '' },
    completed: { type: Function, default: () => {} },
    requirements: { type: Array, default: () => [] },
    running: { type: Boolean, default: false },
    submit: { type: Function, default: () => {} },
    price: { type: Object, default: () => {} },
    variant: { type: String, default: '' },
  },

  data() {
    return {
      status: StatusType.IDLE,
    }
  },

  computed: {
    isBlocked() {
      return this.status === StatusType.BLOCKED
    },
    isIdle() {
      return this.status === StatusType.IDLE
    },
    isConfirming() {
      return this.status === StatusType.CONFIRM
    },
    isRunning() {
      return this.status === StatusType.RUNNING
    },
    formatedPrice() {
      if (!this.price || !this.price.value) return
      return this.formatPrice(this.price.value, this.price.currency)
    },
  },

  mounted() {
    if (this.isBookingBlocked) {
      this.status = StatusType.BLOCKED
    } else if (this.running) {
      this.status = StatusType.RUNNING
    }
  },

  methods: {
    async submitBooking() {
      this.status = StatusType.RUNNING
      try {
        await this.submit(this.type, this.slug)
        bus.$emit(eventNames.TRIGGER_ANIMATION)
      } catch (error) {
        this.status = StatusType.IDLE
        bus.$emit(eventNames.SHOW_SNACKBAR, {
          color: 'error',
          text: this.$t('alerts.upselling.error'),
          time: 10000,
        })
      }
    },

    goToIdle() {
      this.status = StatusType.IDLE
    },
    goToConfirm() {
      this.status = StatusType.CONFIRM
    },
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
